import React, {useEffect, useRef, useState} from "react";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import Select from "../elements/Select";
import {setError} from "../../slices/error/ErrorSlice";
import {useDispatch, useSelector} from "react-redux";
import Autocomplete from "../elements/Autocomplete";
import AutocompleteMulti from "../elements/AutocompleteMulti";
import Modal from "../elements/Modal";
import {createRef, getBase64, getFileHandler, checkReExpProductsHaveGroup0708} from "../../functions/functions";
import {headModel, fssProductPattern, fssPattern, reExportProductPattern, reExportPattern, filePattern} from "../../functions/patterns";
import Message from "../elements/Message";
import {useNavigate, useParams} from "react-router-dom";

export default function Postavka() {
    const routerParams = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [headForm, setHeadForm] = useState(headModel());

    const regexpTurkey = /^EC\/TR\s?[AB]\s?\d{7}$/i;
    const regexpAllCountries = /^[\w\s.()\/-]{3,}$/;

    const units     = useSelector(state => state.voc.unit);
    const clients   = useSelector(state => state.voc.client);
    const markings  = useSelector(state => state.voc.markings);
    const kodfito   = useSelector(state => state.voc.kodfito);
    const preinfoStates = useSelector(state => state.voc.preinfoStates);

    const [requestNum, setRequestNum] = useState('');
    const [userPostavka, setUserPostavka] = useState('');
    const [reExport, setReExport] = useState([reExportPattern()]);
    const [fss, setFss] = useState([]);
    const [file, setFile] = useState([filePattern()]);

    const [exporterList, setExporterList] = useState([]);
    const [importerList, setImporterList] = useState([]);
    // const [byorderList, setByorderList] = useState([]);
    const [productionList, setProductionList] = useState({re: {outerIdx: null, pIdx: null, data: []}, fss: {outerIdx: null, pIdx: null, data: []}});
    const [countryList, setCountryList] = useState({re: {outerIdx: null, pIdx: null, data: []}, fss: {outerIdx: null, pIdx: null, data: []}});
    const [modalFssShow, setModalFssShow] = useState(false);
    const [modalMessage, setModalMessage] = useState({show: false, text: ''});
    const [intoFssList, setIntoFssList] = useState([]);

    const [lastModified, setLastModified] = useState(null);
    const [lastOuterIdx, setLastOuterIdx] = useState(null);
    const [lastPIdx, setLastPIdx] = useState(null);

    const isCorrectAllFields = useRef(null);

    const [message, setMessage] = useState({
       header: '',
       headerSmall: '',
       text: '',
       isSuccess: true,
       show: false
    });

    const submitRef = useRef(null);

    const COLOR={
        red:'#FFB6C1',
        green:'#B4EEB4'
    };

    function getPostavka() {
        axios.get(`/api/postavka/${routerParams.id}`)
            .then(res => {
                setRequestNum(res.data.request_num);
                setUserPostavka(res.data.user);

                let newHeadForm = {...headForm}
                for (let prop in res.data.head) {
                    if (headForm.hasOwnProperty(prop) && res.data.head[prop]) {
                       newHeadForm[prop].value = res.data.head[prop]
                    }
                }

                let newReExport = [reExportPattern()];
                res.data.re_exp.forEach((item, index) => {
                    if (index > 0) newReExport.push(reExportPattern());
                    for (let prop in item) {
                        if (reExportPattern().hasOwnProperty(prop) && item[prop]) {
                            if (prop === 'product') {
                                item.product.forEach((itemP, indexP) => {
                                    if (indexP > 0) newReExport[index].product.push(reExportProductPattern());
                                    for (let propP in itemP) {
                                        if (propP === 'id') {
                                            newReExport[index][prop][indexP][propP] = itemP[propP];
                                        } else if (reExportProductPattern().hasOwnProperty(propP) && itemP[propP]) {
                                            newReExport[index][prop][indexP][propP].value = itemP[propP];
                                        }
                                    }
                                })
                            } else if (prop === 'id') {
                                newReExport[index][prop] = item[prop]
                            } else newReExport[index][prop].value = item[prop]
                        }
                    }
                    setReExport(newReExport);
                })

                let nextFss = [];
                res.data.fss.forEach((item, index) => {
                    nextFss.push(fssPattern());

                    for (let prop in item) {
                        if (fssPattern().hasOwnProperty(prop) && item[prop]) {
                            if (prop === 'product') {
                                item.product.forEach((itemP, indexP) => {
                                    if (indexP > 0) nextFss[index].product.push(fssProductPattern());
                                    for (let propP in itemP) {
                                        if (propP === 'id') {
                                            nextFss[index][prop][indexP][propP] = itemP[propP];
                                        } else if (fssProductPattern().hasOwnProperty(propP) && itemP[propP]) {
                                            nextFss[index][prop][indexP][propP].value = itemP[propP];
                                        }
                                    }
                                })
                            } else if (prop === 'id') {
                                nextFss[index][prop] = item[prop];
                            } else if (prop === 'file') {
                                nextFss[index][prop].exist = item[prop].exist
                            } else nextFss[index][prop].value = item[prop]
                        }
                    }


                })
                setFss(nextFss);

                let nextFile = [...file];
                res.data.file.forEach((item, index) => {
                    if (index > 0) nextFile.push(filePattern());

                    for (let prop in item) {
                        if (filePattern().hasOwnProperty(prop) && item[prop]) nextFile[index].exist = item[prop];
                    }

                    setFile(nextFile);
                })
            })
    }

    function submitHandler() {
        allFieldsCheckHandler();

        let data = {head: headForm, re_exp: reExport, fss: fss, file: file};

        let convertedData = convertDataForSend(data);
        console.log(convertedData);
        if (isCorrectAllFields.current) {
            axios.patch(`/api/postavka/${routerParams.id}/edit`, convertedData)
                .then(res=>{
                    console.log('data was updated');
                    setMessage({
                        header: 'Успешно',
                        headerSmall: '',
                        text: 'Данные изменены',
                        isSuccess: true,
                        show: true
                    })
                    submitRef.current.disabled = true;
                })
                // .catch(e=>{})
            // axios.get('/api/colors').then(res => console.log(res.data))
        } else console.log('send error');
    }

    function messageSendHandler() {
        navigate('/view');
    }

    function messageCloseHandler() {
        setMessage({...message, show: false});
        messageSendHandler();
    }

    function  convertDataForSend (dataObjAll) {
        let outObj = {};

        function returnVal(data) {
            let obj = {};
            let arr = [];

            // if (data === null) return;

            if (data && (data.value || data.value === '')) {
                if (typeof data.value !== 'object' && ! Array.isArray(data.value)) {
                    return data.value === '' ? null : data.value;
                } else if (typeof data.value === 'object' && data.value.id) {
                    return data.value;
                } else if (Array.isArray(data.value)) {
                    data.value.forEach(item => {
                        arr.push(item.id);
                    })
                    return arr;
                }
            } else if (data && (typeof data === 'object' && ! data.value)) {
                for (let key in data) {
                    if (key === 'file') {
                        obj = {...obj, [key]: {
                                id: data[key].exist ? data[key].exist.id : null,
                                name: data[key].name,
                                type: data[key].type,
                                value: data[key].value
                            }
                        };
                    } else obj = {...obj, [key]: returnVal(data[key])};
                }
                return obj;
            } else return data;
        }

        for (let prop in dataObjAll) {
            if (prop === 'file') {
                outObj[prop] = [];
                dataObjAll[prop].forEach(item => {
                   item.id = item.exist ? item.exist.id : null;
                   delete item.exist;
                   delete item.ref;
                   outObj[prop].push(item);
               })
            } else outObj[prop] = returnVal(dataObjAll[prop]);
        }

        return outObj;
    }

    function allFieldsCheckHandler() {
        isCorrectAllFields.current = null;

        checkFieldsHandler(headForm);
        reExport.forEach((item, key) => {
            checkFieldsHandler(reExport[key]);
        })
        fss.forEach((item, key) => {
            checkFieldsHandler(fss[key]);
        })

        //Если группа 07-овощи или 08-фрукты, то требуем ввод ФСС страны происхождения.
        if (fss.length === 0 && checkReExpProductsHaveGroup0708(reExport)) {
            setModalMessageHandler('Нужно сосздать ФСС страны происхождения!');
            isCorrectAllFields.current = false;
        }
    }

    function checkExistReExp() {
        if ((lastModified === 'kodfito' || lastModified === 'num') && reExport[lastOuterIdx]['kodfito'] && reExport[lastOuterIdx]['num']) {
            axios.post('/api/postavka/check-exist-numfss', {kodfito: reExport[lastOuterIdx]['kodfito'].value, num: reExport[lastOuterIdx]['num'].value})
                .then(res => {
                    if (res.data) setModalMessageHandler(`Такая поставка уже существует!\n№ поставки: ${res.data.postavka_id}\nДата поставки: ${res.data.postavka_date}\n№ реэкспортного ФСС: ${res.data.fss_num}`)
                })
        }
    }

    function checkFieldsHandler(model) {
        for (let key in model) {
            //костыль для возможности сохрнаить без картинки фсс по клику второй раз на сохранить
            if (key === 'file' && !model[key].value && model[key].ref.current.style.backgroundColor) continue;

            if (key === 'product') {
                model[key].forEach(item => {
                    for (let keyProd in item) {
                        if (item[keyProd] && (item[keyProd].require || item[keyProd].regexp)) {
                            checkFieldHandler(item, keyProd);
                        }
                    }
                })
            }
            if (model[key] && (model[key].require || model[key].regexp)) checkFieldHandler(model, key);
        }
    }

    function checkFieldHandler(model, key) {
        if (model[key].exist) {
            checkField(true);
            return;
        }

        if (model[key].require) {
            if (model[key].regexp) {
                testField(model, key)
            } else {
                let success;
                if (Array.isArray(model[key].value)) {
                    success = model[key].value.length > 0;
                } else if (typeof model[key].value === 'object') {
                    success = model[key].value.id
                } else {
                    success = model[key].value;
                }

                markRequiredField(model[key], success);
                checkField(Boolean(success))
            }
        } else if (model[key].regexp && !model[key].value) {
            model[key].ref.current.style.backgroundColor = 'white';
            // checkField(false);
        } else if (model[key].regexp) {
            testField(model, key)
        }
    }

    function testField(model, key) {
        if (model[key].regexp.test(model[key].value)) {
            model[key].ref.current.style.backgroundColor = COLOR.green;
            if (model[key].valid) model[key].valid.ref.current.style.display = 'none';
            checkField(true);
        } else {
            model[key].ref.current.style.backgroundColor = COLOR.red;
            if (model[key].valid) model[key].valid.ref.current.style.display = 'block';
            checkField(false);
        }
    }

    function markRequiredField(modelItem, success) {
        if (success) {
            modelItem.ref.current.style.backgroundColor = COLOR.green;
        } else modelItem.ref.current.style.backgroundColor = COLOR.red;
    }

    function checkField(boolVal) {
        checkCorrectAllFields(boolVal);
    }

    function checkCorrectAllFields(boolVal) {
        if (isCorrectAllFields.current === null) {
            isCorrectAllFields.current = boolVal;
        } else if (!boolVal) {
            isCorrectAllFields.current = boolVal;
        }
    }

    useEffect(() => {
        if (lastModified && headForm[lastModified]) {
            checkFieldHandler(headForm, lastModified);
        }
    }, [headForm])

    useEffect(() => {
        if (['production', 'country', 'unit', 'netto'].includes(lastModified) && reExport[lastOuterIdx].product[lastPIdx]) {
            checkFieldHandler(reExport[lastOuterIdx].product[lastPIdx], [lastModified]);
        } else if (lastModified && reExport[lastOuterIdx][lastModified]) {
            checkFieldHandler(reExport[lastOuterIdx], [lastModified]);
        }
    }, [reExport])

    useEffect(() => {
        if (['production', 'unit', 'netto'].includes(lastModified) && fss[lastOuterIdx].product[lastPIdx]) {
            checkFieldHandler(fss[lastOuterIdx].product[lastPIdx], [lastModified]);
        } else if ((lastOuterIdx || typeof lastOuterIdx === 'number') && fss[lastOuterIdx][lastModified]) {
            checkFieldHandler(fss[lastOuterIdx], [lastModified]);
        }
    }, [fss])

    useEffect(() => {
        getPostavka();
    }, []);

    function getExporters(name) {
        let withoutArr = headForm.exporter.value.map(function (obj) {
            return obj.id;
        });

        if (headForm.client.value) {
            axios.post('/api/autocomplete/exporter', {name: name, client: headForm.client.value, without: withoutArr})
                .then(res => {
                    setExporterList(res.data)
                })
                .catch(e => {
                    dispatch(setError(e.response.data));
                })
        }
    }

    function clearDataMultiAuto() {
        setTimeout(() => {
            setExporterList([]);
            setImporterList([]);
        }, 300)
    }

    function clearDataSingleAuto() {
        setTimeout(() => {
            let newProductionList = {...productionList};
            newProductionList = {...newProductionList, re: {...newProductionList.re, data: []}};
            newProductionList = {...newProductionList, fss: {...newProductionList.fss, data: []}};

            let newCountryList = {...countryList};
            newCountryList = {...newCountryList, re: {...newCountryList.re, data: []}};
            newCountryList = {...newCountryList, fss: {...newCountryList.fss, data: []}};

            setProductionList(newProductionList);
            setCountryList(newCountryList);
        }, 300)
    }

    // function getByorders(name) {
    //     let withoutArr = headForm.byorder.value.map(function (obj) {
    //         return obj.id;
    //     });
    //
    //     axios.post('/api/autocomplete/byorder', {name: name, without: withoutArr})
    //         .then(res => {
    //             setByorderList(res.data)
    //         })
    //         .catch(e => {
    //             dispatch(setError(e.response.data));
    //         })
    // }

    function getImporter(name) {
        let withoutArr = headForm.importer.value.map(function (obj) {
            return obj.id;
        });

        if (name) {
            axios.post('/api/autocomplete/importer', {name: name, without: withoutArr})
                .then(res => {
                    setImporterList(res.data)
                })
                .catch(e => {
                    dispatch(setError(e.response.data));
                })
        }
    }

    function changeHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        if (['marking', 'client', 'preinfo_state'].includes(fieldName) && value !== '') value = Number(value);
        if (fieldName === 'client') {
            console.log('clear')
            headForm.exporter.value = []
        }

        setHeadForm({...headForm, [fieldName]: {...headForm[fieldName], value: value}});
        setLastModified(e.target.id);
    }

    function choiceAutocomleteMultiHandler(obj, name) {
        setHeadForm({...headForm, [name]: {...headForm[name], value: [...headForm[name].value, obj]}});
        setLastModified(name);
    }

    function choiceAutocomplete(name, section, obj, pIdx, outerIdx) {
        if (section === 're') {
            let nextReExp = [...reExport];

            if (obj) {
                nextReExp[outerIdx].product[pIdx] = {
                    ...nextReExp[outerIdx].product[pIdx],
                    [name]: {...nextReExp[outerIdx].product[pIdx][name], value: {id: obj.id, name: obj.name}}
                };
            } else {
                nextReExp[outerIdx].product[pIdx] = {
                    ...nextReExp[outerIdx].product[pIdx],
                    [name]: {...nextReExp[outerIdx].product[pIdx][name], value: {id: null, name: ''}}
                };
            }
            setReExport(nextReExp);
        } else if (section === 'fss') {
            let nextFss = [...fss];

            if (obj) {
                if (name === 'country') {
                    nextFss[outerIdx] = {
                        ...nextFss[outerIdx],
                        [name]: {...nextFss[outerIdx][name], value: {id: obj.id, name: obj.name}}
                    }

                    //изменение шаблона ФСС для Турции
                    if (obj.id === 161) {
                        nextFss[outerIdx] = {
                            ...nextFss[outerIdx],
                            num: {...nextFss[outerIdx].num, regexp: regexpTurkey}
                        }
                        nextFss[outerIdx] = {
                            ...nextFss[outerIdx],
                            num: {...nextFss[outerIdx].num, valid: {...nextFss[outerIdx].num.valid, info: 'Не верный формат ФСС Турции!\n EC/TR Серия(A или B) №(7 цифр)\n EC/TR A 1234567'}}
                        }
                        if (nextFss[outerIdx].num.value) checkFieldHandler(nextFss[outerIdx], 'num')
                    } else if (obj.id !== 161) {
                        nextFss[outerIdx] = {
                            ...nextFss[outerIdx],
                            num: {...nextFss[outerIdx].num, regexp: regexpAllCountries}
                        }
                        nextFss[outerIdx] = {
                            ...nextFss[outerIdx],
                            num: {...nextFss[outerIdx].num, valid: {...nextFss[outerIdx].num.valid, info: ''}}
                        }
                        if (nextFss[outerIdx].num.value) checkFieldHandler(nextFss[outerIdx], 'num')
                    }
                } else if (name === 'production') {
                    nextFss[outerIdx].product[pIdx] = {
                        ...nextFss[outerIdx].product[pIdx],
                        [name]: {...nextFss[outerIdx].product[pIdx][name], value: {id: obj.id, name: obj.name}}
                    }
                }
            } else {
                if (name === 'country') {
                    nextFss[outerIdx] = {
                        ...nextFss[outerIdx],
                        [name]: {...nextFss[outerIdx][name], value: {id: null, name: ''}}
                    }
                } else if (name === 'production') {
                    nextFss[outerIdx].product[pIdx] = {
                        ...nextFss[outerIdx].product[pIdx],
                        [name]: {...nextFss[outerIdx].product[pIdx][name], value: {id: null, name: ''}}
                    }
                }
            }
            setFss(nextFss);
        }
        setLastModified(name);
        setLastOuterIdx(outerIdx);
        setLastPIdx(pIdx);
    }

    function delExporter(e) {
        let idx = e.currentTarget.parentNode.getAttribute('idx');
        let newArr = headForm.exporter.value;
        newArr.splice(idx, 1);
        setHeadForm({...headForm, exporter: {...headForm.exporter, value: newArr}});
    }

    function delByorder(e) {
        let idx = e.currentTarget.parentNode.getAttribute('idx');
        let newArr = headForm.byorder.value;
        newArr.splice(idx, 1);
        setHeadForm({...headForm, byorder: {...headForm.byorder, value: newArr}});
    }

    function delImporter(e) {
        let idx = e.currentTarget.parentNode.getAttribute('idx');
        let newArr = headForm.importer.value;
        newArr.splice(idx, 1);
        setHeadForm({...headForm, importer: {...headForm.importer, value: newArr}});
    }

    function getProduction(name, fieldSection, outerIdx, pIdx) {
        if (name) {
            axios.get('/api/autocomplete/production', {params: {name: name}})
                .then(res => {
                    setProductionList({
                        ...productionList,
                        [fieldSection]: {outerIdx: outerIdx, pIdx: pIdx, data: res.data}
                    })
                })
                .catch(e => {
                    dispatch(setError(e.response.data));
                })
        }
    }

    function getCountry(name, fieldSection, outerIdx, pIdx) {
        if (name) {
            axios.get('/api/autocomplete/country', {params: {name: name}})
                .then(res => {
                    setCountryList({...countryList, [fieldSection]: {outerIdx: outerIdx, pIdx: pIdx, data: res.data}})
                })
                .catch(e => {
                    dispatch(setError(e.response.data));
                })
        }
    }

    function getProductionByField(outerIdx, pIdx, fieldSection) {
        if (productionList[fieldSection].outerIdx === outerIdx && productionList[fieldSection].pIdx === pIdx) {
            return productionList[fieldSection].data
        } else return [];
    }

    function getCountryByField(outerIdx, pIdx, fieldSection) {
        if (countryList[fieldSection].outerIdx === outerIdx && countryList[fieldSection].pIdx === pIdx) {
            return countryList[fieldSection].data
        } else return [];
    }

    function getKodfitoDisabled(index) {
        if (index > '0' && reExport[0].kodfito) {
            return true;
        } else {
            return false;
        }
    }

    function addReExportRawHandler() {
        let nextReExp = [...reExport];
        let newItem = reExportPattern();

        if (reExport[0].kodfito) newItem.kodfito.value = reExport[0].kodfito.value;
        nextReExp.push(newItem);

        setReExport(nextReExp);
    }

    function removeReExportRawHandler(e) {
        var reIdx = e.target.parentNode.parentNode.getAttribute('reidx');
        let nextReExport = [...reExport];

        if (reExport.length > 1) {
            nextReExport.splice(reIdx, 1);
            setReExport(nextReExport);

            setLastModified(null);
            setLastOuterIdx(null);
            setLastPIdx(null);
        }
    }

    function addProductRowReExpHandler(e) {
        let index = e.target.getAttribute('idx');
        addProductRowReExp(index);
    }

    function addProductRowReExp(index) {
        let nextReExp = [...reExport];
        let lastProduction = reExport[index].product[reExport[index].product.length - 1];
        let newProduction = reExportProductPattern();
        newProduction.production.value = lastProduction.production.value;
        newProduction.country.value = lastProduction.country.value;
        newProduction.netto.value = lastProduction.netto.value;
        newProduction.unit.value = lastProduction.unit.value;

        nextReExp[index].product.push(newProduction);

        setReExport(nextReExp);
    }

    function removeProductRowExpHandler(e) {
        let reIdx = e.target.parentNode.parentNode.getAttribute('reidx');
        let pIdx = e.target.parentNode.parentNode.getAttribute('pidx');

        if (reExport[reIdx].product.length > 1) {
            let nextReExport = [...reExport];

            nextReExport[reIdx].product.splice(pIdx, 1);

            setReExport(nextReExport);
        }
    }

    function changeReExportHandler(e) {
        let idx;

        if (e.target.name === 'kodfito') {
            idx = e.target.parentNode.parentNode.parentNode.getAttribute('reidx');
            let nextReExport = [...reExport];

            if (idx === '0' || ! reExport[0].kodfito.value) {
                nextReExport[idx] = {...nextReExport[idx], kodfito: {...nextReExport[idx].kodfito, value: e.target.value ? Number(e.target.value) : ''}};
            }

            if (reExport.length > 1 && idx === '0') {
                nextReExport.forEach((o, index) => {
                    if (index !== 0) o.kodfito.value = nextReExport[0].kodfito.value
                });
            }

            setReExport(nextReExport);
        }

        if (e.target.name === 'num') {
            idx = e.target.parentNode.parentNode.parentNode.getAttribute('reidx');
            let nextReExport = [...reExport];
            nextReExport[idx] = {...nextReExport[idx], num: {...nextReExport[idx].num, value: e.target.value}};
            setReExport(nextReExport);
        }

        if (e.target.name === 'date') {
            idx = e.target.parentNode.parentNode.getAttribute('reidx');
            let nextReExport = [...reExport];
            nextReExport[idx].date.value = e.target.value

            setReExport(nextReExport);
        }
        setLastModified(e.target.name);
        setLastOuterIdx(idx);
    }

    function changeReExportProductHandler(e) {
        let reIdx = e.target.parentNode.parentNode.getAttribute('reidx');
        let pIdx = e.target.parentNode.parentNode.getAttribute('pidx');
        let nextReExport = [...reExport];
        let name = e.target.name;

        nextReExport[reIdx].product[pIdx] = {...nextReExport[reIdx].product[pIdx], [name]: {...nextReExport[reIdx].product[pIdx][name], value: e.target.value}};
        setReExport(nextReExport);

        setLastModified(name);
        setLastOuterIdx(reIdx);
        setLastPIdx(pIdx);
    }

    function addFssRowHandler() {
        let nextFss = [...fss];
        nextFss.push(fssPattern());

        setFss(nextFss);
    }

    function removeFssRawHandler(e) {
        let fssIdx = e.target.parentNode.parentNode.getAttribute('fssidx');
        let nextFss = [...fss];

        if (fss.length > 1) {
            nextFss.splice(fssIdx, 1);
            setFss(nextFss);
            removeIntoFss(Number(fssIdx));
        }
        if (fss.length === 1) {
            setModalFssShow(true);
        }

        setLastModified(null);
        setLastOuterIdx(null);
        setLastPIdx(null);
    }

    function addProductRowFssHandler(e) {
        let index = e.target.getAttribute('idx');
        let nextFss = [...fss];
        nextFss[index].product.push(fssProductPattern());

        setFss(nextFss);
    }

    function removeProductFssHandler(e) {
        let fssIdx = e.target.parentNode.parentNode.getAttribute('fssidx');
        let pIdx = e.target.parentNode.parentNode.getAttribute('pidx');

        if (fss[fssIdx].product.length > 1) {
            let nextFss = [...fss];

            nextFss[fssIdx].product.splice(pIdx, 1);

            setFss(nextFss);
        }
    }

    function changeFssHandler(e) {
        let fssIdx = e.target.parentNode.parentNode.getAttribute('fssidx');
        let name = e.target.name;

        let nextFss = [...fss];
        if (name === 'file') {
            fssIdx = e.target.parentNode.parentNode.parentNode.getAttribute('fssidx');
            let fileInp = e.target.files[0];
            getBase64(fileInp)
                .then(res => {
                    nextFss[fssIdx] = {...nextFss[fssIdx], [name]: {...nextFss[fssIdx][name], exist: null}};
                    nextFss[fssIdx] = {...nextFss[fssIdx], [name]: {...nextFss[fssIdx][name], name: fileInp.name}};
                    nextFss[fssIdx] = {...nextFss[fssIdx], [name]: {...nextFss[fssIdx][name], type: fileInp.type}};
                    nextFss[fssIdx] = {...nextFss[fssIdx], [name]: {...nextFss[fssIdx][name], value: res}};

                    setFss(nextFss);
                })
        } else {
            nextFss[fssIdx] = {...nextFss[fssIdx], [name]: {...nextFss[fssIdx][name], value: e.target.value}};

            setFss(nextFss);
        }

        setLastModified(name);
        setLastOuterIdx(fssIdx);
    }

    function changeFssProductHandler(e) {
        let fssIdx = e.target.parentNode.parentNode.getAttribute('fssidx');
        let pIdx = e.target.parentNode.parentNode.getAttribute('pidx');
        let nextFss = [...fss];
        let name = e.target.name;

        nextFss[fssIdx].product[pIdx] = {...nextFss[fssIdx].product[pIdx], [name]: {...nextFss[fssIdx].product[pIdx][name], value: e.target.value}};
        setFss(nextFss);

        setLastModified(name);
        setLastOuterIdx(fssIdx);
        setLastPIdx(pIdx);
    }

    function createFssHandler(e) {
        let reIdx = e.target.parentNode.parentNode.getAttribute('reidx');
        let pIdx = e.target.parentNode.parentNode.getAttribute('pidx');
        let nextFss = [...fss];
        let addedFss = fssPattern();

        addedFss.country.value = reExport[reIdx].product[pIdx].country.value;
        addedFss.country.ref = createRef();
        addedFss.product[0].netto.value =  reExport[reIdx].product[pIdx].netto.value;
        addedFss.product[0].unit.value =  reExport[reIdx].product[pIdx].unit.value;
        addedFss.product[0].production.value = reExport[reIdx].product[pIdx].production.value
        nextFss.push(addedFss);

        setLastModified(null);
        setLastOuterIdx(null);
        setLastPIdx(null);

        setFss(nextFss);
    }

    function removeFssFirstRowHandler() {
        setFss([]);
        removeIntoFss(Number(0));
        closeModalFssHandler();
    }

    function clearInputFssFileValue(e) {
        let fssIdx = e.target.parentNode.parentNode.parentNode.getAttribute('fssidx');
        let nextFss = [...fss];
        nextFss[fssIdx].file.exist = null;
        nextFss[fssIdx].file.name = '';
        nextFss[fssIdx].file.type = '';
        nextFss[fssIdx].file.value = '';

        setFss(nextFss);

        nextFss[fssIdx].file.ref.current.value = '';
    }

    function sumProducts(productsArr) {
        let sumObj = {};
        productsArr.forEach((item) => {
            if (item.unit.value && item.netto.value) {
                let objUnit = units.find(o => o.id === Number(item.unit.value))

                let unitName = objUnit.name;
                if (sumObj[unitName]) {
                    sumObj[unitName] += Number(item.netto.value);
                } else sumObj[unitName] = Number(item.netto.value);
            }
        })

        let outStr = ''
        for (let prop in sumObj) {
            outStr += sumObj[prop] + " ("+prop+")" + "; "
        }

        return outStr;
    }

    function changeFileHandler(e) {
        let fId = e.target.getAttribute('fid');
        let nextFiles = [...file];
        let fileInp = e.target.files[0];

        getBase64(fileInp)
            .then(res => {
                nextFiles[fId].exist = null;
                nextFiles[fId].name = fileInp.name;
                nextFiles[fId].type = fileInp.type;
                nextFiles[fId].value = res

                setFile(nextFiles);
            })
        // nextFiles[fId].value = e.target.value;
        // setFile(nextFiles);
    }

    function addFileRow() {
        let nextFile = [...file];
        nextFile.push(filePattern());
        setFile(nextFile);
    }

    function delFileRowHandler(e) {
        if (file.length > 1) {
            let fId = e.currentTarget.previousSibling.getAttribute('fid');
            let nextFile = [...file];
            nextFile.splice(fId, 1);
            setFile(nextFile);
        }
    }

    function clearInputFileValue(e) {
        let fIdx = e.target.getAttribute('fid');
        let nextFile = [...file];
        nextFile[fIdx].name = '';
        nextFile[fIdx].type = '';
        nextFile[fIdx].value = '';

        setFile(nextFile);
        nextFile[fIdx].ref.current.value = '';
    }

    function closeModalFssHandler() {
        setModalFssShow(!modalFssShow);
    }

    function modalMessageShowHandler() {
        setModalMessage({...modalMessage, show: ! modalMessage.show});
    }

    function setModalMessageHandler(text) {
        setModalMessage({text: text, show: true});
    }

    function intoFssListHandler(e) {
        let fssIdx = Number(e.target.parentNode.parentNode.getAttribute('fssidx'));
        let nextIntoFssList = [...intoFssList];

        if (e.target.checked) {
            nextIntoFssList.push(fssIdx);
        } else {
            let index = nextIntoFssList.indexOf(fssIdx);
            if (index !== -1) {
                nextIntoFssList.splice(index, 1);
            }
        }

        setIntoFssList(nextIntoFssList);
    }

    function removeIntoFss(val) {
        let nextIntoFssList = [...intoFssList];
        let index = nextIntoFssList.indexOf(val);

        if (index !== -1) {
            nextIntoFssList.splice(index, 1);
            setIntoFssList(nextIntoFssList);
        }
    }

    function addIntoFssHandler(e) {
        if (intoFssList.length === 0) return;

        let reIdx = e.target.parentNode.parentNode.getAttribute('reidx');
        let pIdx = e.target.parentNode.parentNode.getAttribute('pidx');

        let addedProduction = {...reExport[reIdx].product[pIdx]};
        addedProduction.id = null;
        delete addedProduction.country;

        let nextFss = [...fss];

        intoFssList.forEach(item => {
            nextFss[item].product.push(addedProduction);
        })

        setFss(nextFss)
    }

    function removeExistFssFile(e) {
        let idx = e.target.parentNode.parentNode.parentNode.getAttribute('fssidx');

        let nextFss = [...fss];
        nextFss[idx].file.exist = null
        setFss(nextFss);
    }

    function removeExistFile(e) {
        let idx = e.target.parentNode.parentNode.getAttribute('fidx');

        let nextFile = [...file];
        nextFile[idx].exist = null
        setFile(nextFile);
    }

    let rowsExp = headForm.exporter.value.map((item, index) =>
        <div className='selected-items' key={item.id} idx={index} iid={item.id}>
            {item.name}
            <span className='close-chosen' onClick={delExporter}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     className="bi bi-x-circle red" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
            </span>
        </div>
    )

    // let rowsByorder = headForm.byorder.value.map((item, index) =>
    //     <div className='selected-items' key={item.id} idx={index} iid={item.id}>
    //         {item.name}
    //         <span className='close-chosen' onClick={delByorder}>
    //             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
    //                  className="bi bi-x-circle red" viewBox="0 0 16 16">
    //                 <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
    //                 <path
    //                     d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
    //             </svg>
    //         </span>
    //     </div>
    // )

    let rowsImporter = headForm.importer.value.map((item, index) =>
        <div className='selected-items' key={item.id} idx={index} iid={item.id}>
            {item.name}
            <span className='close-chosen' onClick={delImporter}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     className="bi bi-x-circle red" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
            </span>
        </div>
    )

    function getReExpProductsRows(indexReExp) {
        let rows = reExport[indexReExp].product.map((item, index) => {
            if (index !== 0) {
                return <tr key={indexReExp+10+index} reidx={indexReExp} pidx={index} className='align-middle table-bordered'>
                    <td>
                        <Autocomplete
                            data={getProductionByField(indexReExp, index, 're')}
                            search={getProduction}
                            value={reExport[indexReExp].product[index].production.value.name}
                            pIdx={index}
                            outerIdx={indexReExp}
                            name='production'
                            section='re'
                            choiceHandler={choiceAutocomplete}
                            clear={clearDataSingleAuto}
                            ref={reExport[indexReExp].product[index].production.ref}
                        />
                    </td>
                    <td>
                        <input type='text' className="form-control border" name='netto' idx={index} ref={reExport[indexReExp].product[index].netto.ref}
                               value={reExport[indexReExp].product[index].netto.value} onChange={changeReExportProductHandler}/>
                    </td>
                    <td>
                        <Select data={units} name='unit' value={reExport[indexReExp].product[index].unit.value}
                                handler={changeReExportProductHandler} ref={reExport[indexReExp].product[index].unit.ref}/>
                    </td>
                    <td>
                        <Autocomplete
                            data={getCountryByField(indexReExp, index, 're')}
                            search={getCountry}
                            value={reExport[indexReExp].product[index].country.value.name}
                            pIdx={index}
                            outerIdx={indexReExp}
                            name='country'
                            section='re'
                            choiceHandler={choiceAutocomplete}
                            clear={clearDataSingleAuto}
                            ref={reExport[indexReExp].product[index].country.ref}
                        />
                    </td>
                    <td className='small-text'><span className='hover link' onClick={createFssHandler}>создать ФСС</span></td>
                    <td className='small-text'><span className='hover link' onClick={addIntoFssHandler}>добавить в ФСС</span></td>
                    <td><span className='link hover' onClick={removeProductRowExpHandler}>x</span></td>
                </tr>
            }
        })

        return rows;
    }

    function getFssProductsRows(indexFss) {
        let rows = fss[indexFss].product.map((item, index) => {
            if (index !== 0) {
                return <tr key={indexFss+10+index} fssidx={indexFss} pidx={index} className='align-middle table-bordered'>
                    <td>
                        <Autocomplete
                            data={getProductionByField(indexFss, index, 'fss')}
                            search={getProduction}
                            value={fss[indexFss].product[index].production.value.name}
                            pIdx={index}
                            outerIdx={indexFss}
                            name='production'
                            section='fss'
                            choiceHandler={choiceAutocomplete}
                            clear={clearDataSingleAuto}
                            ref={fss[indexFss].product[index].production.ref}
                        />
                    </td>
                    <td>
                        <input type='text' className="form-control border" name='netto' idx={index}
                               value={fss[indexFss].product[index].netto.value} onChange={changeFssProductHandler}
                               ref={fss[indexFss].product[index].netto.ref}
                        />
                    </td>
                    <td>
                        <Select data={units} name='unit' value={fss[indexFss].product[index].unit.value}
                                handler={changeFssProductHandler} ref={fss[indexFss].product[index].unit.ref}
                        />
                    </td>
                    <td><span className='link hover' onClick={removeProductFssHandler}>x</span></td>
                </tr>
            }
        })

        return rows;
    }

    let rowsReExp = reExport.map((item, index) => {
            let first = <tr key={index * 10} reidx={index} pidx={0} className='align-middle'>
                <td rowSpan={reExport[index].product.length + 1}>
                    <div>
                        <Select
                            data={kodfito}
                            disabled={getKodfitoDisabled(index)}
                            name='kodfito'
                            value={reExport[index].kodfito.value}
                            handler={changeReExportHandler}
                            onBlurHandle={checkExistReExp}
                            ref={reExport[index].kodfito.ref}
                        />
                    </div>
                    <div className='mt-1'>
                        <input type='text' className="form-control ms-1" name='num' value={reExport[index].num.value}
                               onChange={changeReExportHandler} ref={reExport[index].num.ref} onBlur={checkExistReExp}/>
                    </div>
                </td>
                <td rowSpan={reExport[index].product.length + 1}>
                    <input
                        type='date'
                        name='date'
                        className='form-control'
                        value={reExport[index].date.value}
                        onChange={changeReExportHandler}
                        ref={reExport[index].date.ref}
                    />
                </td>
                <td>
                    <Autocomplete
                        data={getProductionByField(index, 0, 're')}
                        search={getProduction}
                        pIdx={0} outerIdx={index}
                        name='production'
                        section="re"
                        value={reExport[index].product[0].production.value.name}
                        choiceHandler={choiceAutocomplete}
                        clear={clearDataSingleAuto}
                        ref={reExport[index].product[0].production.ref}/>
                </td>
                <td>
                    <input type='text' className="form-control" name='netto' value={reExport[index].product[0].netto.value}
                           onChange={changeReExportProductHandler} ref={reExport[index].product[0].netto.ref}/>
                </td>
                <td>
                    <Select
                        data={units}
                        name='unit'
                        value={reExport[index].product[0].unit.value}
                        handler={changeReExportProductHandler}
                        ref={reExport[index].product[0].unit.ref
                    }/>
                </td>
                <td>
                    <Autocomplete
                        data={getCountryByField(index, 0, 're')}
                        search={getCountry}
                        pIdx={0}
                        outerIdx={index}
                        name='country'
                        section='re'
                        value={reExport[index].product[0].country.value.name}
                        choiceHandler={choiceAutocomplete}
                        clear={clearDataSingleAuto}
                        ref={reExport[index].product[0].country.ref}/>
                </td>
                <td style={{width: 110}} className='small-text'><span className='link hover' onClick={createFssHandler}>создать ФСС</span></td>
                <td style={{width: 130}} className='small-text'><span className='link hover' onClick={addIntoFssHandler}>добавить в ФСС</span></td>
                <td style={{width: 30}}><span className='link hover' onClick={removeProductRowExpHandler}>x</span></td>
                <td rowSpan={reExport[index].product.length + 1} className='align-middle' style={{width: 30}}>
                    <span className='link hover' onClick={removeReExportRawHandler}>x</span>
                </td>
            </tr>;

            let middle = getReExpProductsRows(index);

            let end = <tr key={index * 10 + 9} idx={index}>
                <td colSpan='7' className='text-start position-relative'>
                    <span className="add-row" idx={index} onClick={addProductRowReExpHandler}>Добавить строку</span>
                    <span className="sum-prod">Сумма: {sumProducts(reExport[index].product)}</span>
                </td>
            </tr>;

        let delimiter = (index !== reExport.length - 1) ?
            <tr key={index * 10 + 9.5}>
                <td colSpan='10' className='delimiter'></td>
            </tr> : null;

        return [first, middle, end, delimiter]
        }
    )

    let fssRows = fss.map((item, index) => {
        let fileInfo = item.file.exist ?
            <>
                <span fileid={item.file.exist.id} onClick={getFileHandler} className='link hover'>{item.file.exist.source_name}</span>
                <span className='hover ms-2 red' onClick={removeExistFssFile}>x</span>
            </> :
            <span>прикрепите скан файла ФСС</span>;

        let first = <tr key={index * 10} fssidx={index} pidx={0} className='align-middle'>
            <td rowSpan={fss[index].product.length + 1}>
                <input className="form-check-input" type="checkbox" onChange={intoFssListHandler}/>
            </td>
            <td rowSpan={fss[index].product.length + 1}>
                <Autocomplete
                    data={getCountryByField(index, 0, 'fss')}
                    search={getCountry}
                    pIdx={0}
                    outerIdx={index}
                    name='country'
                    section='fss'
                    value={fss[index].country.value.name}
                    choiceHandler={choiceAutocomplete}
                    clear={clearDataSingleAuto}
                    ref={fss[index].country.ref}
                />
                <div className='small-text'>{fileInfo}</div>
                <div className='input-group'>
                    <input type='file' fid={index} className='form-control' name='file' ref={fss[index].file.ref} onChange={changeFssHandler}/>
                    {
                        item.file.value &&
                        <button className="btn btn-outline-secondary p-1" type="button" id="inputGroupFileAddon04"
                                onClick={clearInputFssFileValue}>x</button>
                    }
                </div>
            </td>
            <td rowSpan={fss[index].product.length + 1}>
                <input
                    type='date'
                    name='date'
                    className='form-control'
                    value={fss[index].date.value}
                    onChange={changeFssHandler}
                    ref={fss[index].date.ref}
                />
            </td>
            <td rowSpan={fss[index].product.length + 1}>
                <input type='text' className="form-control" name='num' value={fss[index].num.value}
                       ref={fss[index].num.ref} onChange={changeFssHandler}/>
                <div ref={fss[index].num.valid.ref} className="invalid-feedback">
                    {fss[index].num.valid.info}
                </div>
            </td>
            <td rowSpan={fss[index].product.length + 1}>
                <textarea className="form-control" name='exporter' value={fss[index].exporter.value}
                       ref={fss[index].exporter.ref} onChange={changeFssHandler}/>
            </td>
            <td rowSpan={fss[index].product.length + 1}>
                <textarea className="form-control" name='importer' value={fss[index].importer.value}
                       ref={fss[index].importer.ref} onChange={changeFssHandler}/>
            </td>
            <td>
                <Autocomplete
                    data={getProductionByField(index, 0, 'fss')}
                    search={getProduction}
                    pIdx={0} outerIdx={index}
                    name='production'
                    section='fss'
                    value={fss[index].product[0].production.value.name}
                    choiceHandler={choiceAutocomplete}
                    clear={clearDataSingleAuto}
                    ref={fss[index].product[0].production.ref}
                />
            </td>
            <td>
                <input type='text' className="form-control" name='netto' value={fss[index].product[0].netto.value}
                       ref={fss[index].product[0].netto.ref} onChange={changeFssProductHandler}/>
            </td>
            <td>
                <Select
                    data={units}
                    name='unit'
                    value={fss[index].product[0].unit.value}
                    ref={fss[index].product[0].unit.ref}
                    handler={changeFssProductHandler}
                />
            </td>
            <td><span className='link hover' onClick={removeProductFssHandler} style={{width: 35}}>x</span></td>
            <td rowSpan={fss[index].product.length + 1} className='align-middle' style={{width: 35}}>
                <span className='link hover' onClick={removeFssRawHandler}>x</span>
            </td>
        </tr>

        let middle = getFssProductsRows(index);

        let end = <tr key={index * 10 + 9} idx={index}>
            <td colSpan='4' className='text-start position-relative'>
                <span className="add-row" idx={index} onClick={addProductRowFssHandler}>Добавить строку</span>
                <span className='sum-prod'>Сумма: {sumProducts(fss[index].product)}</span>
            </td>
        </tr>;

        let delimiter = (index !== fss.length - 1) ?
            <tr key={index * 10 + 9.5}>
                <td colSpan='11' className='delimiter'></td>
            </tr> : null;

        return [first, middle, end, delimiter]
    })

    let files = file.map((item, index) =>
        <div className="row align-items-start" key={index} fidx={index}>
            { item.exist &&
                <div className='d-block text-start'>
                    <span className='link hover' fileid={item.exist.id}
                          onClick={getFileHandler}>{item.exist.source_name}</span>
                    <span className='hover ms-2 red' onClick={removeExistFile}>x</span>
                </div>
            }
            <div className='col-3 mt-1 d-inline-flex'>
                <div className='input-group'>
                    <input type='file' fid={index} className='form-control'
                           onChange={changeFileHandler} ref={item.ref}/>
                    {
                        item.value &&
                        <button fid={index} className="btn btn-outline-secondary p-1" type="button"
                                id="inputGroupFileAddon04"
                                onClick={clearInputFileValue}>x
                        </button>
                    }
                </div>
                <span className='link hover ms-2 mt-2' onClick={delFileRowHandler}>
                    <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash hover red"
                         fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                    </svg>
                </span>
            </div>
        </div>
    )

    return (
        <>
            <Modal
                header='Подтвердите действие'
                show={modalFssShow}
                closeHandler={closeModalFssHandler}
            >
                <div className="float-none">Закрыть блок реэкспортного ФСС?</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={removeFssFirstRowHandler}
                           value='Да'/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalFssHandler}
                           value='Нет'/>
                </div>
            </Modal>

            <Modal
                header='Уведомление системы'
                show={modalMessage.show}
                closeHandler={modalMessageShowHandler}
            >
                <div className="float-none" style={{whiteSpace: 'pre-line'}}>{modalMessage.text}</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={modalMessageShowHandler}
                           value='Ок'/>
                </div>
            </Modal>

            <Message data={message} handler={messageSendHandler} closeHandler={messageCloseHandler}/>

            <h1>{'Поставка № ' + routerParams.id}</h1>

            <div className='card bg-light shadow-sm p-2 m-2'>
                <div className="row align-items-start">
                    <div className="col d-inline-flex">
                        <label htmlFor="specialist" className="col-sm-4 col-form-label">Специалист:</label>
                        <div className="col-sm-7">
                            <input type="text" readOnly={true} className="form-control" name='specialist'
                                   id="specialist"
                                   value={userPostavka}/>
                        </div>
                    </div>
                    <div className="col d-inline-flex">
                        <label htmlFor="request" className="col-sm-3 col-form-label">Запрос №:</label>
                        <div className="col-sm-7">
                            <input type="text" readOnly={true} className="form-control" id="request" name='request'
                                   value={requestNum}/>
                        </div>
                    </div>
                    <div className="col">
                        <div className="col d-inline-flex">
                            <label htmlFor="date_postavka" className="col-sm-7 col-form-label">Изменить дату
                                поставки:</label>
                            <div className="col-sm-6">
                                <input
                                    type='date'
                                    id='date_postavka'
                                    name='date_postavka'
                                    className='form-control'
                                    value={headForm.date_postavka.value}
                                    onChange={changeHandler}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col d-inline-flex">
                        <label htmlFor="marking" className="col-sm-5 col-form-label">Пометить:</label>
                        <div className="col-sm-5">
                            <Select data={markings} name='marking' id='marking' value={headForm.marking.value}
                                    handler={changeHandler}/>
                        </div>
                    </div>
                </div>

                <div className="row align-items-start pt-4">
                    <div className="col d-inline-flex">
                        <label htmlFor="client" className="col-sm-1 col-form-label">Клиент:</label>
                        <div className="col-sm-4">
                            <Select data={clients} id='client' name='client' value={headForm.client.value}
                                    handler={changeHandler}
                                    ref={headForm.client.ref}
                            />
                        </div>
                    </div>
                </div>

                <div className="row align-items-start pt-3">
                    <div className='col-sm-1'></div>
                    <div className='col-sm-8 text-start'>{rowsExp}</div>
                </div>
                <div className="row align-items-start pt-1">
                    <div className="col d-inline-flex">
                        <label htmlFor="exporter" className="col-sm-1 col-form-label">Экспортер:</label>
                        <div className="col-sm-8">
                            <AutocompleteMulti
                                data={exporterList}
                                search={getExporters}
                                focusSearch={false}
                                id='exporter'
                                name='exporter'
                                choiceHandler={choiceAutocomleteMultiHandler}
                                clear={clearDataMultiAuto}
                                ref={headForm.exporter.ref}
                            />
                        </div>
                    </div>
                </div>

                <div className="row align-items-end pt-3">
                    <div className='col-sm-1'></div>
                    <div className='col-sm-8 text-start'>{rowsImporter}</div>
                </div>
                <div className="row align-items-start pt-1">
                    <div className="col d-inline-flex">
                        <label htmlFor="importer" className="col-sm-1 col-form-label">Импортер:</label>
                        <div className="col-sm-8">
                            <AutocompleteMulti
                                data={importerList}
                                search={getImporter}
                                name='importer'
                                id='importer'
                                choiceHandler={choiceAutocomleteMultiHandler}
                                clear={clearDataMultiAuto}
                                ref={headForm.importer.ref}
                            />
                        </div>
                    </div>
                </div>

                <div className="row align-items-start pt-3">
                    <div className="col-12 col-md-4 d-inline-flex">
                        <label htmlFor="transp_num" className="col-sm-3 col-form-label">№ трансп.:</label>
                        <div className="col-sm-5">
                            <input type="text" className="form-control" id="transp_num" name='transp_num'
                                   value={headForm.transp_num.value} onChange={changeHandler}
                                   ref={headForm.transp_num.ref}/>
                        </div>
                    </div>
                    <div className='col-12 col-md-8 pt-3 pt-md-0'>
                        <div className="row">
                            <div className="col-auto d-inline-flex">
                                <label htmlFor="preinfo_num" className="col-auto col-form-label me-1">Номер ПИ:</label>
                                <div className="">
                                    <input type="text" className="form-control" id="prinfo_num" name='preinfo_num'
                                           value={headForm.preinfo_num.value} onChange={changeHandler}
                                           ref={headForm.preinfo_num.ref}/>
                                </div>
                            </div>
                            <div className={'col-auto d-inline-flex'}>
                                <label htmlFor="preinfo_state" className="col-auto col-form-label me-1">Статус ПИ:</label>
                                <div className="col-auto ">
                                    <Select
                                        data={preinfoStates}
                                        name='preinfo_state'
                                        value={headForm.preinfo_state.value}
                                        ref={headForm.preinfo_state.ref}
                                        handler={changeHandler}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='card bg-light shadow-sm p-2 m-2 mt-3'>
                <div className="row align-items-start">
                    <span className="col-sm-1 col-form-label">Описание товаров:</span>
                    <div className="col d-inline-flex">
                        <table className="table table-bordered mb-0">
                            <thead className='fs-6'>
                            <tr className='table-th'>
                                <th style={{width: 220}}>Реэкспорт ФСС</th>
                                <th style={{width: 150}}>Дата выдачи</th>
                                <th>Товар</th>
                                <th style={{width: 100}}>Нетто</th>
                                <th style={{width: 100}}>Единицы</th>
                                <th style={{width: 330}}>Страна происхождения (для 06 <br/>группы вводиить страну
                                    отправления)
                                </th>
                                <th colSpan='2'>Действия с ФСС</th>
                                <th colSpan='2'>Удалить</th>
                            </tr>
                            </thead>
                            <tbody>
                            {rowsReExp}

                            <tr className='border border-0'>
                                <td colSpan='10' className='delimiter border border-0 pt-1 pb-0'><span className='hover link' onClick={addReExportRawHandler}>Добавить реэкспортный ФСС</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {fss.length > 0 ?
                <div className='card bg-light shadow-sm p-2 m-2 mt-3'>
                    <div className="row align-items-start">
                        <span className="col-sm-1 col-form-label">ФСС:</span>
                        <div className="col d-inline-flex">
                            <table className="table table-bordered mb-0">
                                <thead className='fs-6'>
                                <tr className='table-th'>
                                    <th style={{width: 20}}></th>
                                    <th style={{width: 220}}>Страна выдачи ФСС</th>
                                    <th style={{width: 150}}>Дата выдачи</th>
                                    <th style={{width: 200}}>Номер ФСС</th>
                                    <th>Экспортёр</th>
                                    <th>Импортёр</th>
                                    <th style={{minWidth: 400}}>Товар</th>
                                    <th style={{width: 100}}>Нетто</th>
                                    <th style={{width: 100}}>Единицы</th>
                                    <th colSpan='2'>Удалить</th>
                                </tr>
                                </thead>
                                <tbody>
                                {fssRows}

                                <tr className='border border-0'>
                                    <td colSpan='10' className='delimiter border border-0 pt-1 pb-0'>
                                        <span className='hover link' onClick={addFssRowHandler}>Добавить ФСС</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                : ''
            }

            <div className='card bg-light shadow-sm p-2 m-2 pt-1 pb-1 mt-3'>
                {files}
                <div className='text-start mt-1'><span className='link hover' onClick={addFileRow}>Добавить строку</span></div>
            </div>

            <div className="text-start m-2">
                <input type='button' className='btn mb-0 btn-success' value='Сохранить' ref={submitRef} onClick={submitHandler}/>
            </div>
        </>
    )
}